import { useNavigate } from "react-router-dom";
import Layout from "../../Common/Components/Layout/Layout";
import { useState, useEffect } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import { getSavedChats, deleteSavedChats } from "../../Services/chat-bot-service";
import style from "./SavedChats.module.css";
import TabTitle from "../../Common/Components/TabTitle/TabTitle";
import { callLogEvent } from "../../Common/Util";
import { NEW_DAILOG } from "../../Common/Constants";
import { Box, Menu, MenuItem } from "@mui/material";
import React from "react";
import share_icon from "../../Assets/Images/share_icon.png";
import download_icon from "../../Assets/Images/download_icon.png";
import mail_icon from "../../Assets/Images/mail_icon.png";
import teams_icon from "../../Assets/svgs/microsoft-teams-svgrepo-com.svg";
import copy_icon from "../../Assets/svgs/content_copy.svg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Spinner } from "react-bootstrap";


const SavedChats = ({ refId, questionRefs }: any) => {
    const email = sessionStorage.getItem("emailid")?.toLowerCase();
    const [isLoading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [savedChats, setSavedChats] = useState<any[]>([]);
    const [showDashboard, setShowDashboard] = useState<boolean>(false);
    const [selectedChatIds, setSelectedChatIds] = useState<string[]>([]);

    const handlePrint = () => {
        const wrapper = document.createElement("div");
        const clonedRefId = refId.cloneNode(true);
        const clonedQuestionId = questionRefs.cloneNode(true);
        clonedQuestionId.styles.fontSize = "30px";
        clonedQuestionId.styles.padding = "20px";
        wrapper.appendChild(clonedQuestionId);
        wrapper.appendChild(clonedRefId);
        document.body.appendChild(wrapper);
        html2canvas(wrapper).then((canvas) => {
            document.body.removeChild(wrapper); // Clean up after capture
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 250;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
            pdf.save("download.pdf");
        });
        handleClose("download");
    };
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        // event.preventDefault();
        callLogEvent("CLICKED_ON_NEW_DAILOG_SHARE_BUTTON", "Clicked on Share icon for viewing sharing options for the message");
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (action: string) => {
        setAnchorEl(null);
        if (action.toUpperCase().trim().replaceAll(' ', '_') !== "SHARE") {
            callLogEvent("CLICKED_ON_NEW_DAILOG_SHARE_" + action.toUpperCase().trim().replaceAll(' ', '_') + "_BUTTON", "Clicked on " + action.toUpperCase().trim().replaceAll(' ', '_') + " icon from sharing options for the message");
        }
    };


    const fetchSavedChats = async () => {
        setLoading(true);
        // Retrieve email from localStorage or sessionStorage
        if (email) {
            try {
                const response = await getSavedChats(email); // Pass the email as an argument
                console.log(response)
                setSavedChats(response);
            } catch (error) {
                console.error("Error fetching saved chats:", error);
            }
        } else {
            console.error("User email not found in localStorage or sessionStorage.");
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchSavedChats();
    }, []);

    const handleDeleteSelected = async () => {
        console.log("Deleting chats with IDs:", selectedChatIds);
        if (!email) {
            console.error("User email not found in localStorage or sessionStorage.");
            return;
        }

        try {
            const payload = {
                chat_ids: selectedChatIds, // the API accepts an array of chat IDs
                email: email,
            };
            const response = await deleteSavedChats(payload);
            if (response && response.message) {
                console.log(response.message);
                // Optionally, refresh the saved chats list after deletion
                fetchSavedChats();
            } else {
                console.error("Unexpected response from deleteSavedChats API:", response);
            }
        } catch (error) {
            console.error("Error deleting saved chats:", error);
        }
    };

    const handleResetToNewChat = () => {
        localStorage.setItem("lastChatHistory", "");
        callLogEvent("CLICKED_WORKSPACE_ASK_AI_BUTTON", "Clicked ASK AI botton");
        navigate(NEW_DAILOG)
    };




    const columns: GridColDef[] = [
        {
            // checkbox
            field: "id",
            headerName: "",
            width: 50,
            sortable: false,
            disableColumnMenu: true
        },
        { field: "question", headerName: "Chat Title", flex: 1 },
        { field: "created_date", headerName: "Created On", flex: 1 },
        {
            field: "action",
            headerName: "Action",
            flex: 2,
            renderCell: (params) => (
                <div className={style.btnOptions}>
                    <span>
                        <button
                            disabled={false}
                            onClick={handleClick}
                            style={{
                                padding: '4px 4px',
                                height: '24px',
                                minHeight: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <img src={share_icon} alt="share" style={{ height: '16px', width: '16px' }} />
                        </button>
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={() => handleClose("share")}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                        >
                            <Box display="flex" >
                                <MenuItem onClick={() => handleClose("email")}><img src={mail_icon} alt="mail" /></MenuItem>
                                <MenuItem onClick={handlePrint}><img src={download_icon} alt="download" /></MenuItem>
                                <MenuItem onClick={() => handleClose("teams")}><img src={teams_icon} alt="teams" style={{ maxHeight: "16px", maxWidth: "16px" }} /></MenuItem>
                                <MenuItem onClick={() => handleClose("copy")}><img src={copy_icon} alt="copy" style={{ maxHeight: "16px", maxWidth: "16px" }} /></MenuItem>
                            </Box>
                        </Menu>
                    </span>
                    <span>
                        <button onClick={handlePrint}><img src={download_icon} alt="download" /></button>
                    </span>
                </div>
            ),
        },
    ];

    return (
        <div className="App">
            <TabTitle title={"Workspaces"} handleClick={handleResetToNewChat} chatTitle="Ask AI" isBackBtn={showDashboard} handleBack={() => setShowDashboard(false)} />
            <div className={style.savedChatsContainer}>
                {isLoading ? <div className={"loaderWrapper"}>
                    <Spinner animation="border" variant="primary">
                        <span className="visually-hidden"></span>
                    </Spinner>
                </div>
                    :
                    savedChats && savedChats.length > 0 ?
                        <div style={{ backgroundColor: "#fff", padding: "16px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
                            <DataGrid
                                rows={savedChats.map((chat) => ({ ...chat, id: chat.id }))} // Ensure each row has a unique `id`
                                columns={columns}
                                checkboxSelection
                                getRowId={(row) => row.request_id} 
                                // disableSelectionOnClick // Prevents selection when clicking on non-checkbox cells
                                onRowSelectionModelChange={(newSelection) => setSelectedChatIds(newSelection as string[])} // Update selected IDs
                                initialState={{
                                    pagination: {
                                        paginationModel: { pageSize: 5 },
                                    },
                                }}
                                pageSizeOptions={[5, 10, 20]}
                            />
                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleDeleteSelected}
                                disabled={selectedChatIds.length === 0}
                                style={{ marginTop: "16px" }}
                            >
                                Delete Selected
                            </Button>
                        </div> : <div> No Saved Chats</div>}
            </div>
        </div>
    );





};

export default Layout(SavedChats);